import { useGetBetHistoryQuery } from '@/store/api/betApi';
import React from 'react';
import { Link, useParams } from 'react-router-dom';
import { useAppSelector } from '@/hooks';

const MyBets = () => {
  const { eventId } = useParams();
  // /game-details is not a protected route, so this renders logged out too and
  // bet history is authenticated — asking for it there only earns a 401.
  const isAuthed = useAppSelector((state) => state.auth.isAuthenticated);
  const { data } = useGetBetHistoryQuery(
    {
      betTime: 'CURRENT',
      eventId: Number(eventId),
      limit: 10,
    },
    // skip for dummy/fallback events (eventId isn't numeric → would error)
    { skip: !isAuthed || (eventId ?? '').startsWith('dummy-') }
  );
  return (
    <div className="bg-gray-200">
      <table className="w-full text-sm">
        {/* Table Head */}
        <thead className="text-gray-800">
          <tr>
            <th className="text-left px-1 py-[2px] font-semibold">Matched Bet</th>
            <th className="text-right px-1 py-[2px] font-semibold">Odds</th>
            <th className="text-right px-1 py-[2px] font-semibold">Stake</th>
          </tr>
        </thead>

        {/* Table Body */}
        <tbody>
          {data?.bets?.map((item, idx) => (
            <tr
              key={`${item.id}-${idx}`}
              className={`border border-table-border ${item?.betOn?.toUpperCase() == 'BACK' ? 'bg-back' : 'bg-lay'} text-black`}
            >
              <td className="px-1 py-[2px]">{item?.selection ?? '-'}</td>
              <td className="px-1 py-[2px] text-right">{item?.odds ?? '-'}</td>
              <td className="px-1 py-[2px] text-right">{item?.amount ?? '-'}</td>
            </tr>
          ))}
        </tbody>
      </table>
      <Link to={'/user/bet-history'} className="block px-1 py-2 font-bold underline">
        See More
      </Link>
    </div>
  );
};

export default MyBets;
